import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@core/animations/route.animations';

@Component({
  selector: 'app-under-construction',
  templateUrl: './under-construction.component.html',
  styleUrls: ['./under-construction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnderConstructionComponent implements OnInit {
  @Input() theme: string;

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  constructor() { }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {
  }

}
